import { render } from "./Deployment.vue?vue&type=template&id=2d2198f4&scoped=true&ts=true"
import script from "./Deployment.vue?vue&type=script&lang=ts"
export * from "./Deployment.vue?vue&type=script&lang=ts"

import "./Deployment.vue?vue&type=style&index=0&id=2d2198f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2198f4"]])

export default __exports__